import * as React from "react"
import {delay, mixed} from "../tsutil"
import {Container, Message} from "semantic-ui-react"

interface State {
  versions: Set<string>
}

export class OutOfDateAppWarning extends React.Component<{}, State> {
  /**
   * Used to stop the new version polling once this component is unmounted.
   */
  mounted = true

  constructor(props: {}) {
    super(props)
    this.state = {versions: new Set()}
    // Stupid trick to avoid tslint's no-floating-promises and IDEA's unhandled promise
    // inspection at the same time.
    const fun: () => void = () => this.startPolling()
    fun()
  }

  async startPolling() {
    while (this.mounted) {
      // For a prod build (yarn build), index.html contains references to merged and minified
      // javascript and css files with a hash in the name, so an index.html that differs at all
      // from the previous one indicates a new version of the app. For dev builds (yarn start)
      // there are no file hashes in index.html so this test doesn't work, but for a dev build
      // you get hot reloading anyway so the whole thing is moot.
      // Our webpack/deployment config could change in the future so that this no longer works
      // (or worse, index.html always gets served as different), in which case we will have to
      // come up with something else.
      // There is also an "asset-manifest.json" file in the build directory we could use as
      // well, but that file doesn't exist for dev builds and I'd rather not produce 404 errors
      // in dev.
      const response = await fetch("/index.html", {cache: "no-cache"})
      const body = await response.text()
      if (!response.ok) {
        // Not sure what else to do here but throw
        throw new Error(`fetch() returned ${response.status} ${response.status}: ${body}`)
      }
      this.setState(({versions}) => {
        // Don't even bother creating a new Set if the version hasn't changed, since that will be
        // common case.
        if (!versions.has(body)) {
          // React state is supposed to be immutable so we have to create a new set
          versions = new Set(versions)
          versions.add(body)
        }
        return {versions}
      })
      await delay(5 * 60 * 1000)
    }
  }

  componentWillUnmount(): void {
    this.mounted = false
  }

  onReload = (e: React.MouseEvent<mixed>) => {
    e.preventDefault()
    window.location.reload()
  }

  render() {
    if (this.state.versions.size <= 1) {
      return null
    }

    return (
      <Container>
        <Message warning style={{margin: "1em"}}>
          There is a new version of this application available. Please save any work in progress and
          then click{" "}
          <a onClick={this.onReload} href="#">
            here
          </a>{" "}
          to reload.
        </Message>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OutOfDateAppWarning.tsx